import { loadersSelector, rawSelector } from './root';
import { propNameSelector } from '../utils';
import { createSelector } from 'reselect';
import { groupBy } from 'lodash';

export const rawListSelector = propNameSelector(rawSelector, 'list');
export const categoryRawListSelector = propNameSelector(rawSelector, 'categories');
export const pagingRawSelector = propNameSelector(rawSelector, 'paging');
export const sortingRawSelector = propNameSelector(rawSelector, 'sorting');
export const countRawsSelector = propNameSelector(rawSelector, 'count');
export const detailRawSelector = propNameSelector(rawSelector, 'detail');
export const loaderRawSelector = propNameSelector(loadersSelector, 'raw');
export const loaderRawsSelector = propNameSelector(loadersSelector, 'raws');
export const loaderDetailRawSelector = propNameSelector(loadersSelector, 'detailRaw');
export const loaderCategoriesRawSelector = propNameSelector(loadersSelector, 'categoryRaw');
export const activeCategoryRawSelector = propNameSelector(rawSelector, 'activeCategory');
export const loaderModalCategoryRawSelector = propNameSelector(loadersSelector, 'productCategory');
export const loaderModalRawSelector = propNameSelector(loadersSelector, 'modalRaw');
export const loaderUpdateRawSelector = propNameSelector(loadersSelector, 'updateRaw');
export const loaderDeleteRawSelector = propNameSelector(loadersSelector, 'deleteRaw');

export const loaderRecipeRawSelector = propNameSelector(loadersSelector, 'receipes');
export const loaderModalRecipeSelector = propNameSelector(loadersSelector, 'modalRecipe');
export const loaderEditRecipeRawSelector = propNameSelector(loadersSelector, 'editRawRecipes');

export const selectedCategoryRaws = createSelector(
    rawListSelector,
    activeCategoryRawSelector,
    (items, id) => items.filter((item) => item.productscategory.id === id),
);

export const selectedRawsByType = (type) => createSelector(
    rawListSelector,
    (items) => items.filter((item) => item.productscategory.type === type),
);

export const categoryRawById = (id) => createSelector(
    categoryRawListSelector,
    (items) => items.find((item) => item.id === id),
);

export const rawById = (id) => createSelector(
    rawListSelector,
    detailRawSelector,
    (items, detail) => {
        if (detail && detail.id === id) return detail;
        return items.find((item) => item.id === id);
    },
);

export const categoriesRawByType = (type) => createSelector(
    categoryRawListSelector,
    (items) => items.filter((item) => item.type === type),
);

export const rawsByCategory = createSelector(
  [selectedRawsByType('raw'), categoriesRawByType('raw')],
  (raws, categories) => {
    const byCategoryId = groupBy(raws, (item) => item.productscategory.id);
    return categories.map((cat) => ({
      label: cat.title,
      options: (byCategoryId[cat.id] || []).map((item) => ({
        value: item.id,
        label: item.name,
      })),
    }));
  }
);